import React from "react"
import styled from "styled-components"
import { breakpoints } from "buoy-theme"
import Section from "../Section"
import { HeadingTwo, Paragraph } from "buoy-core"
import Button from "../Button"
import responsive from "../../common/responsive"
import { generatePageUrl, getImageUrl } from "../../common/utils"

const AboutSection = styled(Section)`
  ${responsive("padding-bottom", "110px", "52ch", "50ch", "40ch")};
  background-repeat: no-repeat;
  text-align: center;
  ${props => responsive(
    'background-image',
    `url(${props.image.xl})`,
    `url(${props.image.lg})`,
    `url(${props.image.md})`,
    `url(${props.image.sm})`
    )}
  ${responsive(
    "background-size",
    "auto 50ch",
    "auto 50ch",
    "auto 50ch",
    "auto 40ch"
  )}
  ${responsive(
    "background-position",
    "56% center",
    "30% 98%",
    "15% 98%",
    "20% 98%"
  )}
`

const About = ({ headline, image, body, button, symptomCheckerPath }) => (
  <AboutSection image={image}>
    <HeadingTwo>{headline}</HeadingTwo>
    <Paragraph maxWidth="500px" margin="0 0 40px" center>
      {body}
    </Paragraph>
    <Button large arrow href={generatePageUrl(symptomCheckerPath)}>
      {button}
    </Button>
  </AboutSection>
)

class AboutContainer extends React.Component {
  constructor(props) {
    super(props)
    let imgSrc = getImageUrl(props.image + "?auto=format,compress&crop=fit&px=16&blur=200")

    this.state = {
      image: {
        sm: imgSrc + "&h=720",
        md: imgSrc + "&h=900",
        lg: imgSrc + "&h=934",
        xl: imgSrc + "&h=940",
      }
    }
  }

  componentDidMount() {
    const hdImage = new Image()
    let imgSrc = getImageUrl(this.props.image + "?auto=format,compress&crop=fit")
    let newState = { image : {} }
    let screenWidth = window.innerWidth

    if (screenWidth <= breakpoints.sm) {
      hdImage.src = imgSrc + "&h=720"
      newState = {
        image: {
          sm: hdImage.src,
          md: imgSrc + "&h=900",
          lg: imgSrc + "&h=934",
          xl: imgSrc + "&h=940",
        }
      }
    }
    else if (screenWidth <= breakpoints.md) {
      hdImage.src = imgSrc + "&h=900"
      newState = {
        image: {
          sm: hdImage.src,
          md: hdImage.src,
          lg: imgSrc + "&h=934",
          xl: imgSrc + "&h=940",
        }
      }
    }
    else if (screenWidth <= breakpoints.lg) {
      hdImage.src = imgSrc + "&h=934"
      newState = {
        image: {
          sm: hdImage.src,
          md: hdImage.src,
          lg: hdImage.src,
          xl: imgSrc + "&h=940",
        }
      }
    }
    else {
      hdImage.src = imgSrc + "&h=940"
      newState = {
        image: {
          sm: hdImage.src,
          md: hdImage.src,
          lg: hdImage.src,
          xl: hdImage.src,
        }
      }
    }

    hdImage.onload = () => {
      this.setState(newState)
    }
  }

  render() {
    return <About {...this.props} {...this.state} />
  }
}

export { AboutContainer as default }



// WEBPACK FOOTER //
// ./src/components/About/index.js